<div #xuxDndItemContainer class="xux-dnd-list-item-container"></div>
